import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import LinearProgress from "@mui/material/LinearProgress";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useEffect, useState } from "react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";
import Layout from "../../components/layout";
import ValidationModal from "../BootstrapValidationModal";
import salonService from "../../services/salonServices";
import bookingService from "../../services/booking";
import Multiselect from "multiselect-react-dropdown";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import Select from "react-select";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { IconButton } from "@mui/material";
import userService from "../../services/UserService";
import { DecryptData, EncryptData, jsonParser } from "../../helpers/helper";

export default function EditBooking() {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [progress, setProgress] = React.useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingModalOpen, setIsSubmittingModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState<
    { id: number, name: string; price: number; serviceType: string, relatedServices: [] }[]
  >([]);
  const [name, setName] = useState<string | null>(null);
  const [nameError, setNameError] = useState(false);
  const [optionData, setOptionData] = useState([]);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [serviceDetails, setServiceDetails] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState<number | null>(null);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [descriptionText, setDescriptionText] = useState("");
  const [comments, setComments] = useState("");
  const [commentsError, setCommentsError] = useState(false);
  const [usersId, setUsersId] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateError, setSelectedDateError] = useState(false);
  const [isDiscount, setIsDiscount] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [GrandTottal, setGrandTotal] = useState(0);
  const [discountInAmount, setDiscountInAmount] = useState(0);
  const [discountInPercentage, setDiscountInPercentage] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isEmailSearch, setIsEmailSearch] = useState(false);
  const [isNameSearch, setIsNameSearch] = useState(false);
  const [isPhoneNumberSearch, setIsPhoneNumberSearch] = useState(false);

  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#719879"
        : state.isFocused
          ? "rgb(245, 245, 245)"
          : "white",
      color: state.isSelected ? "white" : "black",
    }),
    control: (base, state) => ({
      ...base,
      maxWidth: "90%",
      borderColor: nameError
        ? "red"
        : state.isFocused
          ? "#719879"
          : "#ccc",
      boxShadow: state.isFocused && !nameError
        ? "0 0 0 1px #719879"
        : nameError
          ? "0 0 0 1px red"
          : null,
      "&:hover": {
        borderColor: nameError
          ? "red"
          : state.isFocused
            ? "#719879"
            : "#aaa",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1d1d1f",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#aaa",
    }),
  }
  useEffect(() => {
    const fetchname = async () => {
      const datas = await salonService.findAllWithPackage();
      const decryptDatas = await DecryptData(datas.serviceData);
      const parsedDatas = jsonParser(decryptDatas);
      setOptionData(parsedDatas);
      const data = await userService.findCustomers();
      const decryptData = await DecryptData(data);
      const parsedData = jsonParser(decryptData)
      const transformedData = parsedData.map(async (user) => {
        // Decrypt specific properties (e.g., first_name)
        const decryptedfullName = DecryptData(user.full_name)
        const decryptedEmail = DecryptData(user.email);
        const decryptedPhoneNumber = DecryptData(user.phone_no);
        const decryptedAddress = DecryptData(user.address);
        // Return a new object with decrypted properties and the rest unchanged
        return {
          ...user, // Spread all existing properties
          full_name: decryptedfullName,
          email: decryptedEmail,
          address: decryptedAddress,
          phone_no: decryptedPhoneNumber,
        };
      });

      // Wait for all promises in the map to resolve
      const resolvedData = await Promise.all(transformedData);
      setUsers(resolvedData);
    };
    fetchname();
  }, []);

  const groupedOptions = optionData.map((service) => ({
    id: service.id,
    name: DecryptData(service.serviceName), // Display name and price
    price: Number(DecryptData(service.price)),
    group: DecryptData(service.name) || "Uncategorized", // Group by service type
    relatedServices: service.relatedService || null
  }));

  useEffect(() => {
    let intervalId;
    let isMounted = true;

    const startProgress = () => {
      intervalId = setInterval(() => {
        setProgress((oldProgress) => {
          const newProgress = oldProgress + 100 / steps;
          if (newProgress >= 100) {
            clearInterval(intervalId);
            setTimeout(() => {
              if (isMounted) {
                setIsSubmittingModalOpen(false);
                history.push(`/booking`);
              }
            }, 500);
            return 100;
          }
          return newProgress;
        });
      }, intervalDuration);
    };

    const intervalDuration = 30;
    const totalTime = 1000;
    const steps = totalTime / intervalDuration;

    if (isSubmittingModalOpen) {
      startProgress();
    }

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [isSubmittingModalOpen]);

  const handleToggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };
  const handleInputChanges = (index, field, value) => {
    const updated = [...serviceDetails];

    let numericValue = parseFloat(value) || 0;

    // Enforce max limit
    if (numericValue > 25) {
      numericValue = 25;
    }

    updated[index][field] = numericValue;

    setServiceDetails(updated);
  };

  const handleInputChangesDiscount = (index, field, value) => {
    // Step 1: Create a copy of the serviceDetails array
    const updated = [...serviceDetails];

    // Step 2: Get the service at the given index
    const service = updated[index]; // 👈 This is where `index` is used!

    // Step 3: Parse the input value as a number
    const parsedValue = parseFloat(value);

    // Step 4: Handle discount change (in dollars)
    if (field === "discount") {
      let amount = isNaN(parsedValue) ? 0 : parsedValue;
      const totalPrice = service.price * service.quantity;

      if (amount > totalPrice) {
        amount = totalPrice;
      }

      const percent = totalPrice > 0 ? (amount / totalPrice) * 100 : 0;

      service.discount = amount;
      service.discountInPercentage = Number(percent.toFixed(2));
    }


    // Step 5: Handle discount change (in percentage)
    if (field === "discountInPercentage") {
      const percent = isNaN(parsedValue) ? 0 : Math.min(parsedValue, 100); // cap at 100%
      const amount = ((percent / 100) * service.price * service.quantity);

      service.discountInPercentage = percent;
      service.discount = Number(amount.toFixed(2));
    }

    if (value > 0) {
      setIsDiscount(true)
    }

    if (value === 0) {
      setIsDiscount(false)
    }
    // Step 6: Update state with modified service list
    setServiceDetails(updated);
  };

  useEffect(() => {
    const calculatedFinal = Math.max(totalPrice - discountInAmount, 0);
    setGrandTotal(calculatedFinal)
  }, [discountInAmount, totalPrice])

  useEffect(() => {
    // Initialize serviceDetails whenever selectedValues change
    if (selectedValues.length > 0) {

      const newDetails = selectedValues.map((svc) => {
        const existing = serviceDetails.find((s) => s.name === svc.name);
        return {
          id: svc.id,
          name: svc.name,
          price: svc.price,
          quantity: existing?.quantity || 1,
          discount: existing?.discount || 0,
          total: existing?.total || 0,
          relatedService: svc.relatedServices || []
        };
      });
      setServiceDetails(newDetails);

    }
  }, [selectedValues]);

  const calculateTotal = (price, quantity, discount) => {
    return (price * quantity - discount).toFixed(2);
  };

  useEffect(() => {
    const total = serviceDetails.reduce((sum, svc) => {
      const totalSvcPrice = svc.price * svc.quantity - svc.discount;
      return sum + (totalSvcPrice > 0 ? totalSvcPrice : 0);
    }, 0);

    setTotalPrice(total);
    setGrandTotal(total)
  }, [serviceDetails]);

  useEffect(() => {
    if (!id || groupedOptions.length === 0) return;

    const fetchUserData = async (id) => {
      try {
        const datas = await bookingService.findOne(id);
        const decryptData = await DecryptData(datas);
        const parsedData = jsonParser(decryptData);
        const serviceData = parsedData.services.map((s) => {
          const fullService = groupedOptions.find((svc) => svc.id === s.id);
          if (!fullService) return null;

          return {
            id: fullService.id,
            name: fullService.name,
            price: fullService.price,
            serviceType: fullService.group,
            relatedServices: fullService.relatedServices || [],
          };
        }).filter(Boolean); // remove nulls

        const decryptedServicesData = parsedData.servicesData.map((service) => ({
          id: service.id,
          name: DecryptData(service.name),
          price: Number(DecryptData(service.price)),  // Convert to number after decryption
          discount: service.discount !== null ? Number(DecryptData(service.discount)) : 0,
          quantity: service.quantity !== null ? Number(DecryptData(service.quantity)) : 1,
          total: service ? Number(DecryptData(service.total)) : Number((Number(DecryptData(service.price)) * Number(DecryptData(service.quantity))) - Number(DecryptData(service.discount))),
          relatedService: service.relatedServices.map(item => ({
            services: {
              serviceName: item.serviceName, // Map 'name' to 'serviceName'
              price: item.servicePrice // Map 'price' to 'price'
            }
          }))
        }));


        const amount = (Number(DecryptData(parsedData.totalPrice)) * Number(DecryptData(parsedData.discountInPercentage))) / 100
        setSelectedValues(serviceData);
        setName(DecryptData(parsedData.name));
        setEmail(DecryptData(parsedData.email));
        setPhoneNumber(DecryptData(parsedData.phoneNumber))
        const date = dayjs(parsedData.date);
        setComments(DecryptData(parsedData.comments));
        setSelectedDate(date);
        setServiceDetails(decryptedServicesData);
        setTotalPrice(Number(DecryptData(parsedData.totalPrice)));
        setGrandTotal(Number(DecryptData(parsedData.grandTotal)));
        setDiscountInPercentage(Number(DecryptData(parsedData.discountInPercentage)));
        setDiscountInAmount(amount)
        setReason(DecryptData(parsedData.reason));
        discountInPercentage > 0 ? setIsDiscount(true) : setIsDiscount(false);


        const matchedUser = users.find((user) => user.id === parsedData.userId);
        if (matchedUser) {
          const formattedUser = {
            value: matchedUser.id,
            label: matchedUser.full_name
              ? matchedUser.full_name
              : matchedUser.email
                ? `${matchedUser.email} - ${matchedUser.full_name}`
                : `${matchedUser.phone_no} - ${matchedUser.full_name}`,
            ...matchedUser,
          };
          handleSelects(formattedUser);
        }
        setIsVisible(true)
      } catch (error) {
        console.error("Error fetching booking data:", error);
      }
    };

    fetchUserData(id);
  }, [id, optionData, users]);

  const handleChangeReason = (e) => {
    let { value } = e.target;

    value = value.replace(/[^a-zA-Z0-9 ]/g, '');


    if (value.length <= 500 || value.length < descriptionText.length) {
      setReason(value);
    }
    if (value !== "") {
      setReasonError(false);
    }
  };
  useEffect(() => {
    const percent = isNaN(discountInPercentage) ? 0 : Math.min(discountInPercentage, 100); // cap at 100%
    const amount = ((percent / 100) * totalPrice);

    setDiscountInAmount(Number(amount.toFixed(2)))
  }, [totalPrice])
  const handleDiscountInputChanges = (event) => {
    const { value, name } = event.target;
    const parsedValue = parseFloat(value);
    if (name === "discount") {
      const amount = isNaN(parsedValue) ? 0 : parsedValue;
      const percent = (amount / (totalPrice)) * 100;

      setDiscountInAmount(amount)
      setDiscountInPercentage(Number(percent.toFixed(2)));
    }

    // Step 5: Handle discount change (in percentage)
    if (name === "discountInPercentage") {
      const percent = isNaN(parsedValue) ? 0 : Math.min(parsedValue, 100); // cap at 100%
      const amount = ((percent / 100) * totalPrice);

      setDiscountInAmount(Number(amount.toFixed(2)))
      setDiscountInPercentage(percent);
    }
    if (value > 0) {
      setIsDiscount(true)
    }
    if (value === 0) {
      setIsDiscount(false)
    }
  };



  const onSubmit = async (record) => {
    let error = 0;

    // Reset all error states before validation
    setCommentsError(false);
    setNameError(false);
    setEmailError(false);
    setPhoneNumberError(false);

    if (selectedDate === null) {
      error += 1;
      setSelectedDateError(true);
    }
    if (selectedOption === null) {
      setNameError(true)
      error += 1;
    }
    if (isDiscount === true) {
      if (reason === "") {
        setReasonError(true)
        error += 1
      } else {
        setReasonError(false)
      }
    }

    // If there are validation errors, open the modal and stop further execution
    if (error > 0) {
      setIsModalOpen(true);
      return;
    }

    // If no errors, proceed with form submission
    setIsSubmitting(true);

    try {
      const serviceData = selectedValues.map(async (data) => {
        // Return a new object with encrypted properties
        return {
          id: data.id
        };
      });


      // Wait for all promises to resolve
      const service = await Promise.all(serviceData);
      // Log input data for debugging
      const payload = {
        bookingDate: selectedDate,
        services: service,
        reason: EncryptData(reason),
        discountInPercentage: EncryptData(Math.round(discountInPercentage).toString()),
        totalPrice: EncryptData(Math.round(totalPrice).toString()),
        GrandTotal: EncryptData(Math.round(GrandTottal).toString()),
        name: EncryptData(name),
        comments: EncryptData(comments),
        ...(email
          ? { emailorPhonrNumber: EncryptData(email) }
          : {}),
        ...(phoneNumber
          ? { emailorPhonrNumber: EncryptData(phoneNumber) }
          : {}),
      };
      // Call the API to save the data
      await bookingService.update(id, payload);
      const discountService = serviceDetails.map((service) => {
        return {
          bookingId: id,
          serviceId: service.id,
          quantity: EncryptData((service.quantity).toString()),
          discount: EncryptData((service.discount).toString()),
          total: service.total === 0 ? EncryptData(((service.total * service.quantity) - service.discount).toString()) : EncryptData(service.total)
        }
      })
      await bookingService.discountServicesUpdate(id, { discountService })
      // Open success modal
      setIsSubmittingModalOpen(true);
    } catch (err) {
      // Reset submitting state
      setIsSubmitting(false);
    }
  };

  const closeSubmittingModal = () => {
    setIsSubmittingModalOpen(false);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      setSelectedDateError(false);
    }
  };
  const handleChangecomments = (e) => {

    let { value } = e.target;

    // Allow only alphanumeric characters (letters and numbers)
    value = value.replace(/[^a-zA-Z0-9 ]/g, '');

    setComments(value);

    if (value !== '') {
      setCommentsError(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (event) => {
    let numericValue = event.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    if (numericValue > totalPrice) {
      numericValue = totalPrice
    }
    event.target.value = numericValue; // Update the input field value
  };

  const handleSelect = (selectedList) => {
    const updatedSelectedValues = selectedList.map((item) => {
      // Find the corresponding option in groupedOptions to get the correct group value
      const originalOption = groupedOptions.find(
        (option) => option.name === item.name
      );
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        serviceType: originalOption?.group || "Uncategorized", // Use the group value from groupedOptions
        relatedServices: item.relatedServices
      };
    });

    setSelectedValues(updatedSelectedValues);
  };


  const handleRemove = (selectedList) => {
    const updatedSelectedValues = selectedList.map((item) => {
      // Find the corresponding option in groupedOptions to get the correct group value
      const originalOption = groupedOptions.find(
        (option) => option.name === item.name
      );
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        serviceType: originalOption?.group || "Uncategorized", // Use the group value from groupedOptions
        relatedServices: item.relatedServices
      };
    });

    setSelectedValues(updatedSelectedValues);
  };

  const formatOptions = (users) =>
    users.map((user) => ({
      label: isEmailSearch
        ? `${user.email} (${user.full_name})`
        : isPhoneNumberSearch
          ? `${user.phone_no}  (${user.full_name})`
          : `${user.full_name}`,
      ...user,
    }));

  const customFilter = (option, searchText) => {
    const lowerCaseSearchText = searchText.toLowerCase();
    const label = option.label?.toLowerCase() || "";
    const email = option.email?.toLowerCase() || "";
    const phone = option.phone_no || "";

    // Regular expressions for detection
    const emailRegex = /(@|gmail|\.com)/i; // Matches valid email format
    const phoneRegex = /^\d{2,}/;

    // Detect search type
    if (emailRegex.test(lowerCaseSearchText)) {
      setIsEmailSearch(true);
      setIsNameSearch(false);
      setIsPhoneNumberSearch(false);
    } else if (phoneRegex.test(lowerCaseSearchText)) {
      setIsPhoneNumberSearch(true);
      setIsEmailSearch(false);
      setIsNameSearch(false);
    } else {
      setIsNameSearch(true);
      setIsPhoneNumberSearch(false);
      setIsEmailSearch(false);
    }
    return (
      label.includes(lowerCaseSearchText) ||
      email.includes(lowerCaseSearchText) ||
      phone.includes(searchText)
    );
  };

  const handleSelects = (selectedOption) => {
    if (selectedOption) {
      setName(
        selectedOption.full_name
      );
      setEmail(
        selectedOption.email ? selectedOption.email : selectedOption.phone_no
      );
      setPhoneNumber(selectedOption?.phone_no);
      setUsersId(selectedOption.id);
      setSelectedOption(selectedOption);
    } else {
      setName("");
      setEmail("");
      setPhoneNumber(null);
      setUsersId(null);
      setSelectedOption(null);
    }
  };

  return (
    <Layout>
      <div className="leavesIndex">
        <h4 className="attendance_overview_heading">Edit Booking</h4>

        <div className="leavesIndex__body">
          <div className="leavesIndex__body_padding">
            <Box
              component="form"
              noValidate
              sx={{
                display: "grid",
                gridTemplateColumns: { sm: "1fr 1fr" },
                gap: 2,
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "1vw",
                  }}
                >
                  <div className="singleInputField singleInputFieldWithoutBorder singleInputHoliday singleInputAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Select Customer
                    </InputLabel>
                    <Select
                      options={formatOptions(users)}
                      placeholder="Search by name / email / phone no"
                      value={selectedOption}
                      onChange={handleSelects}
                      filterOption={(option, searchText) =>
                        customFilter(option.data, searchText)
                      }
                      isClearable
                      isSearchable
                      styles={customStyles}

                    />
                  </div>
                  <div className="singleInputField singleInputFieldWithoutBorder singleInputHoliday singleInputAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Select Booking Date
                    </InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DateTimePicker"]}>
                        <DateTimePicker
                          onChange={handleDateChange}
                          className={`leaveDurationInput ${selectedDateError ? "leaveDurationInput-error" : ""
                            } newLeaveScreen announcementDateAndTime `}
                          value={selectedDate}
                          minDateTime={dayjs()}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "1vw",
                  }}
                >
                  <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Select Service
                    </InputLabel>
                    {optionData.length > 0 && (
                      <div
                        style={{
                          marginTop: "1vw",
                          position: "relative",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {/* Container for Multiselect and IconButton */}
                        <div
                          style={{
                            position: "relative",
                            width: "100%", // Ensure the container spans the full width
                          }}
                        >
                          {/* Multiselect Component */}
                          <Multiselect
                            options={groupedOptions} // Use the grouped options
                            selectedValues={selectedValues}
                            onSelect={handleSelect}
                            onRemove={handleRemove}
                            displayValue="name" // Display the name field
                            groupBy="group" // Group by the 'group' field
                            style={{
                              chips: { background: "#3f51b5" }, // Customize chips (optional)
                              multiselectContainer: {
                                width: "100%", // Full width of the container
                              },
                              searchBox: {
                                padding: "12px", // Add padding to accommodate the icon
                                paddingRight: "20px", // Extra padding on the right for the icon
                              },
                            }}
                          />

                          {/* IconButton Positioned Inside the Multiselect */}
                          <IconButton
                            onClick={handleToggleVisibility}
                            style={{
                              position: "absolute",
                              right: "0", // Position it inside the Multiselect
                              top: "50%",
                              transform: "translateY(-50%)", // Center vertically
                              background: "transparent", // Make the button transparent
                            }}
                            aria-label="toggle visibility"
                          >
                            {isVisible ? <ArrowDropUpIcon fontSize="large" /> : <ArrowDropDownIcon fontSize="large" />}
                          </IconButton>
                        </div>
                      </div>
                    )}
                    {isVisible && selectedValues.length > 0 && (
                      <div
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "4px",

                          maxHeight: "max-content", // height for ~6 lines
                          overflowY: "auto",
                          marginTop: "8px",
                          width: '100%',
                          backgroundColor: "white",
                        }}
                      >
                        <div style={{ backgroundColor: "#f9f9f9", padding: "10px", display: "flex", gap: "10px", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                          <div style={{ width: "250px", }}><strong>Name</strong> </div>
                          <div style={{ width: "100px", }}><strong>Price</strong></div>
                          <div style={{ width: "100px", }}><strong>Quantity</strong></div>
                          <div style={{ width: "100px", }}><strong>Discount in Amount </strong></div>
                          <div style={{ width: "100px", }}><strong>Discount in percentage </strong></div>
                          <div style={{ width: "100px", }}><strong>Total</strong></div>
                        </div>

                        {serviceDetails.map((svc, index) => {
                          const related = svc.relatedService || [];

                          return (
                            <React.Fragment key={svc.name}>
                              <div key={svc.name} style={{ backgroundColor: "white", padding: "10px", display: "flex", gap: "10px", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ width: "250px" }}>

                                  {svc.name}
                                </div>
                                <div style={{ width: "100px" }}>

                                  {svc.price.toFixed(2)}
                                </div>
                                <div style={{ width: "100px" }}>

                                  <input
                                    type="text"
                                    min="1"
                                    value={svc.quantity}
                                    onChange={(e) => handleInputChanges(index, "quantity", e.target.value)}
                                    style={{ width: "100px", padding: "4px" }}
                                  />
                                </div>

                                <div style={{ width: "100px" }}>

                                  <input
                                    type="text"
                                    min="0"
                                    value={svc.discount}
                                    onChange={(e) => handleInputChangesDiscount(index, "discount", e.target.value)}
                                    style={{ width: "100px", padding: "4px" }}
                                  />
                                </div>

                                <div style={{ width: "100px" }}>

                                  <input
                                    type="text"
                                    min="0"
                                    value={svc.discountInPercentage}
                                    onChange={(e) => handleInputChangesDiscount(index, "discountInPercentage", e.target.value)}
                                    style={{ width: "100px", padding: "4px" }}
                                  />
                                </div>

                                <div style={{ width: "100px" }}>
                                  <div>{svc.total = calculateTotal(svc.price, svc.quantity, svc.discount)}</div>
                                </div>

                              </div>
                              {related.length > 0 && (
                                <div
                                  style={{
                                    paddingLeft: "20px",

                                    borderBottom: "1px solid #eee",
                                  }}
                                >
                                  {related.map((rs, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        justifyContent: "space-between",
                                        padding: "1px 0",
                                      }}
                                    >

                                      <div style={{ width: "250px" }}>{DecryptData(rs.services.serviceName)}</div>
                                      <div style={{ width: "100px" }}>{DecryptData(rs.services.price)}</div>
                                      <div style={{ width: "100px", color: "#888" }}>
                                        -
                                      </div>
                                      <div style={{ width: "100px", color: "#888" }}>
                                        -
                                      </div>
                                      <div style={{ width: "100px", color: "#888" }}>
                                        -
                                      </div>
                                      <div style={{ width: "100px", color: "#888" }}>
                                        -
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </React.Fragment>
                          )
                        })}
                        <div
                          style={{
                            backgroundColor: "#f9f9f9", padding: "10px", display: "flex", gap: "10px", flexDirection: "row", justifyContent: "space-between", alignItems: "center"
                          }}
                        >
                          <div style={{ fontSize: "1rem", width: "150px" }}><strong>Total Price:</strong></div>
                          <div style={{ fontSize: "1rem", width: "100px" }}><strong>{totalPrice.toFixed(2)}</strong></div>
                        </div>

                      </div>
                    )}

                  </div>
                </div>
                {selectedValues.length > 0 &&
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1vw",
                    }}
                  >
                    <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                      <InputLabel
                        className="formInputLabels"
                        shrink
                        htmlFor="bootstrap-input"
                      >
                        Grand Total
                      </InputLabel>
                      <FormControl
                        className={`newLeaveScreen  `}
                        variant="standard"
                      >
                        <OutlinedInput
                          name="grandTotal"
                          readOnly
                          value={GrandTottal}
                          placeholder="Enter Grand Total"
                        />
                      </FormControl>
                    </div>
                    <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                      <InputLabel
                        className="formInputLabels"
                        shrink
                        htmlFor="bootstrap-input"
                      >
                        Discount In Amount
                      </InputLabel>
                      <FormControl
                        className={`newLeaveScreen  `}
                        variant="standard"
                      >
                        <OutlinedInput
                          name="discount"
                          onInput={handleInputChange}
                          onChange={handleDiscountInputChanges}
                          value={discountInAmount}
                          placeholder="Enter the discount"
                        />
                      </FormControl>
                    </div>
                    <div className="singleInputField singleInputAnnouncement titleAnnouncement">
                      <InputLabel
                        className="formInputLabels"
                        shrink
                        htmlFor="bootstrap-input"
                      >
                        Discount In Percentage
                      </InputLabel>
                      <FormControl
                        className={`newLeaveScreen  ${phoneNumberError ? "leaveDurationInput-error" : ""
                          }`}
                        variant="standard"
                      >
                        <OutlinedInput
                          name="discountInPercentage"
                          onInput={handleInputChange}
                          onChange={handleDiscountInputChanges}
                          value={discountInPercentage}
                          placeholder="Enter the discount"
                        />
                      </FormControl>
                    </div>
                  </div>}
                {isDiscount === true &&
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: "1vw",
                    }}
                  >
                    <div className="singleInputField singleInputFieldTextArea">
                      <InputLabel
                        className="formInputLabels"
                        shrink
                        htmlFor="bootstrap-input"
                      >
                        Reason for discount
                      </InputLabel>
                      <FormControl variant="standard">
                        <textarea
                          className={`leaveDurationTextArea leaveDurationInput ${reasonError
                            ? "leaveDurationInput-error"
                            : ""
                            }`}
                          onChange={handleChangeReason}
                          value={reason}
                          placeholder="Enter text here..."
                          rows={6}
                          cols={50}
                        />
                      </FormControl>
                    </div>
                  </div>
                }
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "1vw",
                  }}
                >
                  <div className="singleInputField singleInputFieldTextArea">
                    <InputLabel
                      className="formInputLabels"
                      shrink
                      htmlFor="bootstrap-input"
                    >
                      Comments
                    </InputLabel>
                    <FormControl variant="standard">
                      <textarea
                        className={`leaveDurationTextArea leaveDurationInput ${commentsError ? "leaveDurationInput-error" : ""
                          }`}
                        onChange={handleChangecomments}
                        value={comments}
                        placeholder="Enter text here..."
                        rows={6}
                        cols={50}
                      />
                    </FormControl>
                  </div>

                  <div></div>
                  {/* <Select
                    multiple
                    value={selectedOptions} // Bind the selected options to the state
                    onChange={handleChangeService} // Handle changes
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', gap: '0.25rem', flexWrap: 'wrap' }}>
                        {selected.map((selectedOption) => (
                          <Chip key={selectedOption} variant="soft" color="primary">
                            {selectedOption}
                          </Chip>
                        ))}
                      </Box>
                    )}
                    sx={{ minWidth: '15rem' }}
                    slotProps={{
                      listbox: {
                        sx: {
                          width: '100%',
                        },
                      },
                    }}
                  >
                    
                    <Option value="All">All</Option>


                    {options.map((option) => (
                      <Option key={option} value={option}>
                        {option}
                      </Option>
                    ))}
                  </Select>*/}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="singleInputField"></div>
                <div className="singleInputField">
                  <div className="formButton">
                    <button
                      type="button"
                      disabled={isSubmitting}
                      className="formSubmitButton"
                      onClick={onSubmit}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </div>

        <ValidationModal
          isOpen={isSubmittingModalOpen}
          onClose={closeSubmittingModal}
        >
          <div className="modal__popup">
            <div className="Portal-Login-Form">
              <div className="ProgressModal">
                <Box className="progressOfSubmitting" sx={{ width: "100%" }}>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      height: 15,
                      borderRadius: 10,
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#719879",
                      },
                    }}
                  />
                </Box>
                <span>Submitting Request</span>
              </div>
            </div>
          </div>
        </ValidationModal>
        <ValidationModal isOpen={isModalOpen} onClose={closeModal}>
          <div className="modal__popup">
            <div className="Portal-Login-Form">
              <div className="ValidationModal">
                <span>Please Enter All Fields To Continue!</span>

                <div className="CloseValidationModalButton">
                  <button
                    type="button"
                    disabled={isSubmitting}
                    className="CloseValidationModal"
                    onClick={closeModal}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidationModal>
      </div>
    </Layout>
  );
}
